import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const IC = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Constitution of India: Definition, Source and Framing of the Constitution of India. Salient Features of the Indian Constitution. Preamble of the Constitution.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Fundamental Rights and Duties: Rights To Equality (Article 14-18), Rights to Freedom (Article 19-22), Right against Exploitation (Article 23-24), Rights to Religion and Cultural and Educational Rights of Minorities (Article 25-30). The Directive Principles of State Policy – Its significance and application. Fundamental Duties – Necessary obligations and its nature, legal status and significance.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Executives and Judiciary: Office of President, Vice President and Governor: Power and Functions, Parliament, Emergency Provisions, President Rule; Union Judiciary: Appointment of Judges, Jurisdiction of the Supreme Court, State Judiciary: Power and functions, Writ Jurisdiction.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Centre-States Relation: Is Indian Constitution Federal in Nature, Legislative relations between Union and States, Administrative Relations between Union and States, Financial Relations between Union and States.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Indian Constitution"
      subjectKey="ic"
      branch="CSE"
      semester="2nd Semester"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'ICNotes',
        videos: 'ICVideos'
      }}
    />
  );
};

export default IC;